import { connect } from 'react-redux';
import RecallCreditNoteDialogContent from './RecallCreditNoteDialogContent';
import { bindActionCreators, Dispatch } from 'redux';
import { actions as uiActions } from 'ducks/ui';
import { selectors as staffSelectors } from 'ducks/staff';

const mapStateToProps = (state) => ({
    Warehouse: staffSelectors.staff(state)?.defaultWarehouseEntity,
    Username: staffSelectors.staff(state)?.name,
    Entity: staffSelectors.staff(state)?.defaultSalesEntity
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
    {
        changeConfirmationDialog: uiActions.changeConfirmationDialog
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RecallCreditNoteDialogContent);
